const translation = {
    // Langs (Keep them like this, as they are used in the language switcher)
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',

    // CUSTOM TRANSLATIONS
    'Home': 'Inicio',
    'About': 'Nosotros',
    'Features': 'Características',
    'Stats': 'Estadísticas',
    'Process': 'Proceso',
    'Contact': 'Contacto',
    'Full Name': 'Nombre Completo',
    'Email Address': 'Correo Electrónico',
    'Phone Number': 'Número de Teléfono',
    'How can we help you?': '¿Cómo podemos ayudarte?',
    'i_agree_to_the': 'Acepto la',
    'Privacy Policy': 'Política de Privacidad',
    'and': 'y',
    'Terms of Service': 'Términos de Servicio',
    'Send Message': 'Enviar Mensaje',
    'Services': 'Servicios',
    'Web Design': 'Diseño Web',
    'Web Development': 'Desarrollo Web',
    'Cloud Services': 'Servicios en la Nube',
    'App Development': 'Desarrollo de Aplicaciones',
    'Business Consulting': 'Consultoría Empresarial',
    'Digital businesses': 'Negocios digitales',
    'Company': 'Empresa',
    'Portfolio': 'Portafolio',
    'Apps': 'Aplicaciones',
    'Websites': 'Sitios Web',
    'Business models': 'Modelos de negocio',
    'Connect': 'Conéctate',
    'Instagram': 'Instagram',
    'home': 'inicio',
}

export { translation };
